// ─── Fase 19 · Banner de descuento (verano o referido) ───────────────────────
import { useT } from "./LangContext";
import { C } from "../lib/colors";
import { getDiscount } from "../lib/promo";

export default function PromoBanner({ compact = false }) {
  const { t } = useT();
  const d = getDiscount();
  if (!d.active) return null;

  const isRef = d.kind === "ref";
  const lead = isRef ? t("promo_ref_lead") : t("promo_banner_lead");
  const detail = isRef
    ? t("promo_ref_detail", { code: (d.code || "").toUpperCase() })
    : t("promo_banner_detail");
  const chipColor = isRef ? C.verdigris : C.cinnabar; // referido = verde · verano = rojo

  return (
    <div data-testid="promo-banner" data-kind={d.kind} style={{
      position: "relative", overflow: "hidden",
      display: "flex", alignItems: "center", justifyContent: "center",
      gap: 12, flexWrap: "wrap",
      padding: compact ? "9px 14px" : "12px 18px",
      marginBottom: compact ? 16 : 28,
      background: `linear-gradient(90deg, ${chipColor}22, ${C.oxide}1f 45%, ${C.brass}2b)`,
      border: `1px solid ${C.brass}`,
      boxShadow: `0 6px 26px -14px ${chipColor}`,
    }}>
      <style>{`@keyframes fg-shine{0%{transform:translateX(-140%)}55%,100%{transform:translateX(360%)}}`}</style>
      <span aria-hidden="true" style={{
        position: "absolute", top: 0, bottom: 0, left: 0, width: "38%", pointerEvents: "none",
        background: `linear-gradient(105deg, transparent, ${C.bone}30, transparent)`,
        animation: "fg-shine 4.4s ease-in-out infinite",
      }} />
      <span style={{
        fontFamily: "var(--mono)", fontWeight: 500, fontSize: compact ? 13 : 15,
        color: C.ink, background: chipColor, padding: "3px 9px", letterSpacing: "0.03em",
      }}>−{d.pct}%</span>
      <b style={{
        fontFamily: "var(--mono)", fontSize: compact ? 12 : 13, letterSpacing: "0.09em",
        color: C.brass, textTransform: "uppercase",
      }}>{lead}</b>
      <span style={{
        fontFamily: "var(--mono)", fontSize: compact ? 11 : 12, color: C.bone, letterSpacing: "0.03em",
      }}>{detail}</span>
    </div>
  );
}
